import react, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import swal from 'sweetalert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import InputAdornment from '@mui/material/InputAdornment';
import PaymentIcon from '@mui/icons-material/Payment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Checkbox } from '@mui/material';
import { create_da_wf_step, update_da_wf_step } from '../../../../services/company_admin_service';

const useStyles = makeStyles((theme) => ({
    button: { margin: 8, },
    root: {
        '& > *': {
            margin: 8,
        },
    }
}));

const menuProps = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
    },
    getContentAnchorEl: null, // This is important to anchor to bottom
}

const DA_wf_configuration_modal = ({ directions, add_infos_modal, setadd_infos_modal, setupdate_wf_step, update_wf_step, app_users,
    app_categories, step_types, wf_default_steps, operators }) => {

    const classes = useStyles();

    const [errorText, setErrorText] = useState("");

    const [categories_ids, setcategories_ids] = useState([]);
    const [step_directions, setstep_directions] = useState([]);
    const [users, setusers] = useState([]);
    const [step, setstep] = useState("");
    const [step_type, setstep_type] = useState("");
    const [threshold, setthreshold] = useState("");
    const [operator, setoperator] = useState("");

    const [waiting, setWaiting] = useState(false);

    useEffect(()=>{
        if(update_wf_step){
            console.log(update_wf_step);
            if(update_wf_step.directions) setstep_directions(JSON.parse(update_wf_step.directions));
            setcategories_ids(JSON.parse(update_wf_step.categories_ids));
            setusers(JSON.parse(update_wf_step.users));
            setstep(update_wf_step.step);
            setstep_type(update_wf_step.step_type);
            setthreshold(update_wf_step.threshold);
            setoperator(update_wf_step.operator);
        }
    },[])


    const handleChange_users = (event) => {
        setusers(event.target.value);
    }



    async function submit() {
        setErrorText("");
        if (categories_ids.length==0 || users.length==0 || step=="" || step_type=="") {
            setErrorText("Champs invalides !");
        } else {
            swal({
                title: "Etes-vous sûr ?",
                text: "!!!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
            .then(async (willDelete) => {
              if (willDelete) {
                setWaiting(true);
                let formData = new FormData();
                formData.append("categories_ids",JSON.stringify(categories_ids));
                formData.append("directions",JSON.stringify(step_directions));
                formData.append("users",JSON.stringify(users));
                formData.append("step",step);
                formData.append("step_type",step_type);
                if(step=="threshold"){
                    formData.append("threshold",threshold);
                    formData.append("operator",operator);
                }
                if(update_wf_step){
                    formData.append("id",update_wf_step.id);
                    await update_da_wf_step(formData).then((response)=>{
                        console.log(response.data);
                        setupdate_wf_step(null); setadd_infos_modal(false);
                    }).catch((error)=>{
                        console.log(error.response);
                    })
                }else{
                    await create_da_wf_step(formData).then((response)=>{
                        console.log(response.data);
                        setupdate_wf_step(null); setadd_infos_modal(false);
                    }).catch((error)=>{
                        console.log(error.response);
                    })
                }
                setWaiting(false);
              }
            })
        }
    }

    return (
        <Dialog fullWidth={true} maxWidth={'md'} open={add_infos_modal} onClose={() => { setupdate_wf_step(null); setadd_infos_modal(false) }} aria-labelledby="form-dialog-title" >
            <DialogTitle id="form-dialog-title">
                {!update_wf_step ? "Ajouter" : "Modifier"}
            </DialogTitle>
            <DialogContent>
                <div className="inputs_container">
                    <FormControl variant='standard' className="input_form">
                        <InputLabel id="category-multiselect-label">Directions</InputLabel>
                        <Select
                            labelId="category-multiselect-label"
                            multiple
                            value={step_directions}
                            onChange={(e)=>setstep_directions(e.target.value)}
                            renderValue={(selected) =>
                                directions
                                    .filter(cat => selected.includes(cat.id))
                                    .map(cat => cat.title)
                                    .join(', ')
                            }
                            MenuProps={menuProps} >
                            {directions.map((dir) => (
                                <MenuItem key={"direction_" + dir.id} value={dir.id}>
                                    <Checkbox checked={step_directions.includes(dir.id)} />
                                    <ListItemText primary={dir.title} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl variant='standard' className="input_form">
                        <InputLabel id="category-multiselect-label">Familles d'achats</InputLabel>
                        <Select
                            labelId="category-multiselect-label"
                            multiple
                            value={categories_ids}
                            onChange={(e)=>setcategories_ids(e.target.value)}
                            renderValue={(selected) =>
                                app_categories
                                    .filter(cat => selected.includes(cat.id_category))
                                    .map(cat => cat.name)
                                    .join(', ')
                            }
                            MenuProps={menuProps} >
                            {app_categories.map((category) => (
                                <MenuItem key={"category_" + category.id_category} value={category.id_category}>
                                    <Checkbox checked={categories_ids.includes(category.id_category)} />
                                    <ListItemText primary={category.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl variant='standard' className="input_form">
                        <InputLabel>Etape</InputLabel>

                        <Select value={step} onChange={(e) => { setstep(e.target.value) }}>
                            <MenuItem value="null" disabled>
                                <em>None</em>
                            </MenuItem>
                            {
                                wf_default_steps.map((step) => (
                                    <MenuItem key={"_" + step.step} value={step.step}>{step.label}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>

                </div>
                <div className="inputs_container">

                    
                    <FormControl variant='standard' className="input_form">
                        <InputLabel>Type d'étape</InputLabel>

                        <Select value={step_type} onChange={(e) => { setstep_type(e.target.value) }}>
                            <MenuItem value="null" disabled>
                                <em>None</em>
                            </MenuItem>
                            {
                                step_types.map((type) => (
                                    <MenuItem key={"_" + type.type} value={type.type}>{type.label}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>

                    <FormControl variant='standard' className="input_form">
                        <InputLabel id="users-multiselect-label">Utilisateurs</InputLabel>
                        <Select
                            labelId="users-multiselect-label"
                            multiple
                            value={users}
                            onChange={handleChange_users}
                            renderValue={(selected) =>
                                app_users
                                    .filter(usr => selected.includes(usr.id))
                                    .map(usr => usr.fullName)
                                    .join(', ')
                            }
                            MenuProps={menuProps} >
                            {app_users.map((user) => (
                                <MenuItem key={"user_" + user.id} value={user.id}>
                                    <Checkbox checked={users.includes(user.id)} />
                                    <ListItemText primary={user.fullName} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl variant='standard' className="input_form">
                        <InputLabel>Opérateur</InputLabel>

                        <Select value={operator} onChange={(e) => { setoperator(e.target.value) }}>
                            <MenuItem value="null" disabled>
                                <em>None</em>
                            </MenuItem>
                            {
                                operators.map((op) => (
                                    <MenuItem key={"_" + op.label} value={op.value}>{op.label}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>

                </div>
                <div className="inputs_container">
                    <TextField variant='standard' label="Seuil (DH) " type="number" className="input_form" value={threshold}
                        InputProps={{ startAdornment: (<InputAdornment position="start"> <PaymentIcon className="my_icon" /> </InputAdornment>) }} onChange={(e) => setthreshold(e.target.value)} />

                </div>
            </DialogContent>
            <DialogActions>
                <div className='dialogBottom'>
                    <div>
                        {
                            errorText === ""
                                ? <></>
                                : <p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                                    {errorText}
                                </p>
                        }
                    </div>
                    <div>
                        <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={() => { setupdate_wf_step(null); setadd_infos_modal(false) }}>
                            Annuler
                        </Button>
                        <Button variant="contained" className="submit_but valide_but" startIcon={<AddIcon />} onClick={submit} >
                            {update_wf_step ? "Modifier" : 'Ajouter'}
                        </Button>
                    </div>

                </div>
            </DialogActions>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </Dialog>
    );
}

export default DA_wf_configuration_modal;